function iOS(): boolean {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    // @ts-expect-error msMaxTouchPoints is deprecated IE/Edge property not in modern types
    navigator.msMaxTouchPoints > 0
  )
}

const is_ios: boolean = iOS()

export default (): boolean => {
  return !is_ios
}
